import React, { Component } from 'react';
// import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import { useTranslation, withTranslation, Trans } from 'react-i18next';

import { useHistory } from "react-router-dom";
import { AgGridReact } from '@ag-grid-community/react';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-alpine.css';
import * as DashboardController from './Controller/DashboardController';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ConfirmationAlert from '../../../Utility/Components/ConfirmationAlert';
import { loaderStateTrue, loaderStateFalse } from '../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../GlobalModules/Login/Actions/LoginAction';
import CustomInput from '../../../Utility/Components/CustomInput';
import Utility from '../../../Utility/Utility';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Badge } from 'react-bootstrap';
import ModalGlobal from '../../../Utility/Components/ModalGlobal'
import HomeUtility from '../../Utility/Utility'
import moment from 'moment';
import Config from '../../../Utility/Config';
import GridActionContent from '../../../Utility/Components/GridActionContent'
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import GlobalHeaderFilter from '../../../Utility/Components/GlobalHeaderFilter';
import ErrorBoundary from '../../../Utility/Components/ErrorBoundary';
import CustomButton from '../../../Utility/Components/CustomButton'
import axios from 'axios';
import './Assets/css/dashboard_doc.scss'
//import FBMessageTemplate from '../../../FBMessageTemplate/FBMessageTemplate';
import EventEmitter from '../../../Utility/EventEmitter';
import UtilityGlobal from '../../../GlobalModules/Utility/Utility';
import DatePicker from "@sentisso/react-modern-calendar-datepicker";
import '@sentisso/react-modern-calendar-datepicker/lib/DatePicker.css';
import CampaignChart from './Components/CampaignChart';
import Timezone from '../../../Utility/Timezone';
import ChatHistoryModal from '../../../Utility/Components/ChatHistoryModal';
import PricingAnalyticsChart from './Components/PricingAnalyticsChart';
import TaskCalendar from './Components/TaskCalendar';

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currencyCode: "",
            upperBlockDataSet: {
                "ph_no_block_value": "",
                "display_name_block_value": "",
                "message_limit_block_value": "",
                "quality_rating_block_value": "",
                "ph_no_status_block_value": "",
            },
            // for change dashboard
            conversions: {},
            selectedDayRange: {
                from: {
                    day: new Date().getDate(1),  // First day of the current month
                    month: new Date().getMonth() + 1, // Current month (1-based)
                    year: new Date().getFullYear(),  // Current year
                },
                to: {
                    day: new Date().getDate(), // Current day
                    month: new Date().getMonth() + 1, // Current month (1-based)
                    year: new Date().getFullYear(),  // Current year
                }
            },
            // end for change dashboard
            /* conversions: {
                "business_initiated": {
                    "conversion_name": "",
                    "free": 0,
                    "paid": 0,
                    "total": 0,
                    "approx_cost": 0.00
                },
                "user_initiated": {
                    "conversion_name": "",
                    "free": 0,
                    "paid": 0,
                    "total": 0,
                    "approx_cost": 0.00
                },
                "unknown": {
                    "conversion_name": "",
                    "free": 0,
                    "paid": 0,
                    "total": 0,
                    "approx_cost": 0.00
                },
            }, */
            messaging: {
                "message_sent": 0,
                "message_delivered": 0
            },
            messageTemplate: [],
            notificationsInsights: [],
            contactsInsights: [],
            currentDate: moment().format("YYYY-MM-DD"),
            // startOfMonth: moment().subtract(1,"month").startOf('month').format('YYYY-MM-DD'),
            startOfMonth: moment().startOf('month').format('YYYY-MM-DD'),
            endOfMonth: moment().endOf('month').format('YYYY-MM-DD'),
            fbMessageTemplatePermissionTab: false,
            campaignBroadcastingPermissionTab: false,
            contactPermissionTab: false,

            broadcastModalFlag: false,
            broadcastData: null,
            //global chat
            globalChatModalFlag: false,
            globalChatPhoneNumber: "",
            globalChatName: "",
            lastChatInitiatedAt: "",
            groupMessage: false,
            groupMessageData: {},
            zoominzoomoutflag: "",
            permissionRulesGridMode: null,
            //pricing analytics
            pricingAnalyticsDataSet: null,
            taskData: null,
        }
    }

    componentDidMount() {
        this.setCurrentMonthRange(); // for change dashboard
        this.checkTabRole();
        this.getPhNumberInsights();
        this.getTaskData();
        // this.dashboardMenuLabledata();
        // console.log("startOfMonth============", this.state.startOfMonth)
        // console.log("endOfMonth============", this.state.endOfMonth)
    }

    // for change dashboard
    setCurrentMonthRange = (val = false) => {
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const currentDate = new Date(today);

        this.setState({
            selectedDayRange: {
                from: {
                    day: firstDayOfMonth.getDate(),
                    month: firstDayOfMonth.getMonth() + 1, // Months are 0-indexed
                    year: firstDayOfMonth.getFullYear()
                },
                to: {
                    day: currentDate.getDate(),
                    month: currentDate.getMonth() + 1,
                    year: currentDate.getFullYear()
                }
            },
        }, () => {
            if (val == true) {
                this.resetDatePicker(this.state.selectedDayRange)
            }
        });
    }
    // end for change dashboard

    checkTabRole = async () => {
        const fbMessageTemplatePermission = await UtilityGlobal.getRoleObjectBySubEventKey('template&settings', 'broadcastingTemplate');
        const campaignBroadcastingPermission = await UtilityGlobal.getRoleObjectBySubEventKey('notificationHistory', 'campaignBroadcasting');
        const contactPermission = await UtilityGlobal.getRoleObjectBySubEventKey('contactsManagement', 'contacts');

        if (fbMessageTemplatePermission.length > 0) {
            this.setState({
                fbMessageTemplatePermissionTab: true
            })
        }
        if (campaignBroadcastingPermission.length > 0) {
            this.setState({
                campaignBroadcastingPermissionTab: true
            })
        }
        if (contactPermission.length > 0) {
            this.setState({
                contactPermissionTab: true,
                // permissionRulesGridMode: contactPermission
            })
        }
    }

    dashboardMenuLabledata = () => {
        const { tabGridLabel } = this.props;
        const dashboardMenuLable_dataset = tabGridLabel?.filter(item => item.ui_element_type.includes("tab") && item.screen_name.includes("home") && item.uniq_identifier == "dashboard_menu").map(item => ({ ...item, setting_data: item.setting_data.filter(val => val.current_status == 1) }));
        // console.log("dashboardMenuLable_dataset============", dashboardMenuLable_dataset[0].setting_data)
        return dashboardMenuLable_dataset[0].setting_data;
    }

    getTaskData = () => {
        const { loaderStateTrue, loaderStateFalse } = this.props;
        loaderStateTrue();
        let filterData = { "start": this.state.startOfMonth, "end": this.state.endOfMonth };
        let data = {};
        data["filters"] = JSON.stringify(filterData)
        DashboardController.taskDetails(data).then((response) => {
            loaderStateFalse();
            if (response.success && response.data.length > 0) {
                this.setState({
                    taskData: response.data
                })
            }
        }).catch((error) => {
            loaderStateFalse();
            console.log("error============", error)
        })
    }

    getPhNumberInsights = () => {
        const { loaderStateTrue, loaderStateFalse } = this.props;
        loaderStateTrue();
        let filterData = { "fields": ["id", "account_mode", "certificate", "code_verification_status", "display_phone_number", "eligibility_for_api_business_global_search", "health_status", "is_official_business_account", "is_pin_enabled", "is_preverified_number", "last_onboarded_time", "messaging_limit_tier", "name_status", "new_certificate", "new_name_status", "platform_type", "quality_score", "search_visibility", "status", "throughput", "verified_name"] };
        let data = {};
        data["filters"] = JSON.stringify(filterData)
        const promise = new Promise((resolve, reject) => {
            DashboardController.insightsDetails(data).then((response) => {
                if (response.success) {
                    let qualityScoreReason = response.data.quality_score?.hasOwnProperty('reason') && response.data.quality_score?.reason;
                    let tempScore = response.data.quality_score?.score == "GREEN" ?
                        <span>
                            <span className="rounded-green-span"></span>High</span>
                        : response.data.quality_score?.score == "RED" ?
                            <span>
                                <span className="rounded-red-span"></span>Low
                                {qualityScoreReason ?
                                    <OverlayTrigger overlay={
                                        <Tooltip>{response.data.quality_score?.reason}</Tooltip>
                                    } placement='bottom'>
                                        <i className="fa fa-info-circle" style={{ position: "relative", left: "3px", cursor: "pointer" }}></i>
                                    </OverlayTrigger> : null}
                            </span> :
                            <span><span className="rounded-yellow-span"></span>Medium</span>
                    let noteMessageLimit = response.data.hasOwnProperty('note_message_limit') && response.data.note_message_limit;
                    let tempMessageLimit = <span>
                        {response.data.message_limit + "/24hr"}
                        {noteMessageLimit ?
                            <OverlayTrigger overlay={
                                <Tooltip>{response.data.note_message_limit}</Tooltip>
                            } placement='bottom'>
                                <i className="fa fa-info-circle" style={{ position: "relative", left: "3px", cursor: "pointer" }}></i>
                            </OverlayTrigger> : null}
                    </span>
                    this.setState({
                        currencyCode: response.data.currency,
                        upperBlockDataSet: {
                            "ph_no_block_value": response.data.display_phone_number,
                            "display_name_block_value": response.data.verified_name,
                            "message_limit_block_value": tempMessageLimit,
                            "quality_rating_block_value": tempScore,
                            "ph_no_status_block_value": response.data.status
                        }
                    }, () => {
                        // this.getConversionsInsights();
                        this.getPricingInsights();
                        let quality_score_status = response.data.quality_score?.score == "GREEN" ? "high" : response.data.quality_score?.score == "RED" ? "low" : "medium";
                        // quality_score_status = "medium"
                        localStorage.setItem("quality_score_status", quality_score_status)
                    })
                }
                //loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                loaderStateFalse();
            })
        })
        return promise;
    }

    formatConversionName = (conversation_direction) => {
        const words = conversation_direction.split('_');
        const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
        const result = capitalizedWords.join('-');
        return result;
    }

    getConversionsInsights = (fromDate = "", toDate = "") => {
        const { startOfMonth, endOfMonth } = this.state;
        const { loaderStateTrue, loaderStateFalse } = this.props;
        loaderStateTrue();
        let conversionNameForBusiness = "";
        let conversionNameForUser = "";
        let conversionNameForUnknown = "";
        // for change dashboard
        let filterData = {}
        if (fromDate != "" && toDate != "") {
            filterData = { "metric_type": "conversation_analytics", "start": fromDate, "end": toDate, "granularity": "DAILY", "dimensions": ["CONVERSATION_CATEGORY", "CONVERSATION_TYPE", "COUNTRY", "PHONE", "CONVERSATION_DIRECTION"] };
        } else {
            filterData = { "metric_type": "conversation_analytics", "start": startOfMonth, "end": endOfMonth, "granularity": "DAILY", "dimensions": ["CONVERSATION_CATEGORY", "CONVERSATION_TYPE", "COUNTRY", "PHONE", "CONVERSATION_DIRECTION"] };
        }
        // end for change dashboard
        let data = {};
        data["filters"] = JSON.stringify(filterData)
        const promise = new Promise((resolve, reject) => {
            DashboardController.messagingInsightsDetails(data).then((response) => {
                this.format_conversation_analytics(response, fromDate, toDate); // for change dashboard
            }).catch((error) => {
                console.error("************error*************", error)
                this.setState({
                    conversions: {}
                })
                loaderStateFalse();
            })
        })
        return promise;
    }

    // for change dashboard
    format_conversation_analytics = async (cdata, fromDate = "", toDate = "") => {
        const { loaderStateTrue, loaderStateFalse } = this.props;
        let outputjson = {
            "all_conversations": {
                "total": 0,
                "marketing": 0,
                "utility": 0,
                "service": 0
            },
            "free_conversations": {
                "total": 0,
                "free tier": 0,
            },
            "paid_conversations": {
                "total": 0,
                "marketing": 0,
                "utility": 0,
                "service": 0
            },
            "approximate_charges": {
                "total": 0,
                "marketing": 0,
                "utility": 0,
                "service": 0
            }
        }
        let data_points = cdata?.data?.conversation_analytics?.data?.[0]?.data_points ?? [];
        for (const dp of data_points) {
            let conversation_category = dp["conversation_category"]
            let conversation_type = dp["conversation_type"]
            let conversation = dp["conversation"]
            let cost = dp["cost"]
            if (conversation_type == "REGULAR") {
                outputjson["paid_conversations"]["total"] += conversation
                outputjson["paid_conversations"][conversation_category.toLowerCase()] += conversation
                outputjson["approximate_charges"]["total"] += parseFloat(cost)
                outputjson["approximate_charges"][conversation_category.toLowerCase()] += parseFloat(cost)
            }
            if (conversation_type == "FREE_TIER") {
                outputjson["free_conversations"]["total"] += conversation
                outputjson["free_conversations"]["free tier"] += conversation
            }
            outputjson["all_conversations"]["total"] += conversation
            outputjson["all_conversations"][conversation_category.toLowerCase()] += conversation
        }
        for (let key in outputjson.approximate_charges) {
            outputjson.approximate_charges[key] = parseFloat(outputjson.approximate_charges[key]).toFixed(2);
        }
        // console.log("outputjson============", outputjson)
        this.setState({
            conversions: outputjson
        }, () => {
            if (fromDate == "" && toDate == "") {
                this.getMessagingInsights();
                this.getMessageTemplateInsights();
                this.getNotificationsInsights();
                // this.getAllContactsInsights();
                this.getAllPositiveLeads();
            } else {
                loaderStateFalse();
            }
        })
    }
    // end for change dashboard

    getPricingInsights = (fromDate = "", toDate = "") => {
        const { startOfMonth, endOfMonth } = this.state;
        const { loaderStateTrue, loaderStateFalse } = this.props;
        loaderStateTrue();
        // for change dashboard
        let filterData = {}
        if (fromDate != "" && toDate != "") {
            filterData = { "metric_type": "pricing_analytics", "start": fromDate, "end": toDate, "granularity": "DAILY", "dimensions": ["COUNTRY", "PHONE", "PRICING_CATEGORY", "PRICING_TYPE", "TIER"] };
        } else {
            filterData = { "metric_type": "pricing_analytics", "start": startOfMonth, "end": endOfMonth, "granularity": "DAILY", "dimensions": ["COUNTRY", "PHONE", "PRICING_CATEGORY", "PRICING_TYPE", "TIER"] };
        }
        // end for change dashboard
        let data = {};
        data["filters"] = JSON.stringify(filterData)
        const promise = new Promise((resolve, reject) => {
            DashboardController.messagingPricingInsightsDetails(data).then((response) => {
                this.getGraphDataByCategory(response)
                this.format_pricing_analytics(response, fromDate, toDate); // for change dashboard
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                this.setState({
                    conversions: {}
                })
                loaderStateFalse();
            })
        })
        return promise;
    }

    // Helper: convert UNIX timestamp → YYYY-MM-DD
    toDateString(timestamp) {
        const d = new Date(timestamp * 1000);
        return d.toISOString().split("T")[0];
    }

    getGraphDataByCategory(jsonData) {
        if (jsonData?.data?.pricing_analytics) {
            const dataPoints = jsonData?.data?.pricing_analytics?.data[0]?.data_points;
            const dailyVolumes = {};
            // Aggregate by date + category
            for (const dp of dataPoints) {
                const date = this.toDateString(dp.start);
                const category = dp.pricing_category;
                if (!dailyVolumes[date]) dailyVolumes[date] = {};
                if (!dailyVolumes[date][category]) dailyVolumes[date][category] = 0;
                dailyVolumes[date][category] += dp.volume;
            }

            // Prepare labels and unique categories
            const labels = Object.keys(dailyVolumes).sort();
            const categories = [...new Set(dataPoints.map((dp) => dp.pricing_category))];

            // Compute total volume ("All Delivered") for each day
            const totalVolumes = labels.map((date) => {
                const categoriesForDate = dailyVolumes[date];
                return Object.values(categoriesForDate).reduce((sum, val) => sum + val, 0);
            });

            // Create datasets for each category
            const categoryColors = ["#007bff", "#28a745", "#ffc107", "#dc3545"];
            const datasets = categories.map((cat, i) => ({
                label: cat,
                data: labels.map((date) => dailyVolumes[date][cat] || 0),
                borderColor: categoryColors[i % categoryColors.length],
                backgroundColor: "transparent",
                fill: false,
                tension: 0.2,
                borderWidth: 2,
                borderDash: [5, 5],
            }));

            // Add the "All Delivered" dataset (sum line)
            datasets.push({
                label: "All Delivered",
                data: totalVolumes,
                borderColor: "#6f42c1",
                backgroundColor: "transparent",
                fill: false,
                borderWidth: 3,
                tension: 0.3,
            });
            // console.log("datasets====", datasets)
            // console.log("labels====", labels)
            this.setState({
                pricingAnalyticsDataSet: { datasets, labels }
            })
        }
        // return { datasets, labels };
    }

    // for modified change dashboard pricing_analytics 07-07-2025
    format_pricing_analytics = async (cdata, fromDate = "", toDate = "") => {
        const { loaderStateTrue, loaderStateFalse } = this.props;
        let outputjson = {
            "all_conversations": {
                "total": 0,
                "marketing": 0,
                "utility": 0,
                "service": 0
            },
            "free_conversations": {
                "total": 0,
                "free tier": 0,
            },
            "paid_conversations": {
                "total": 0,
                "marketing": 0,
                "utility": 0,
                "service": 0
            },
            "approximate_charges": {
                "total": 0,
                "marketing": 0,
                "utility": 0,
                "service": 0
            }
        }
        let data_points = cdata?.data?.pricing_analytics?.data?.[0]?.data_points ?? [];
        for (const dp of data_points) {
            let conversation_category = dp["pricing_category"]
            let conversation_type = dp["pricing_type"]
            let conversation = dp["volume"]
            let cost = dp["cost"]
            if (conversation_type == "REGULAR") {
                outputjson["paid_conversations"]["total"] += conversation
                outputjson["paid_conversations"][conversation_category.toLowerCase()] += conversation
                outputjson["approximate_charges"]["total"] += parseFloat(cost)
                outputjson["approximate_charges"][conversation_category.toLowerCase()] += parseFloat(cost)
            }
            if (conversation_type == "FREE_CUSTOMER_SERVICE") {
                outputjson["free_conversations"]["total"] += conversation
                outputjson["free_conversations"]["free tier"] += conversation
            }
            outputjson["all_conversations"]["total"] += conversation
            outputjson["all_conversations"][conversation_category.toLowerCase()] += conversation
        }
        for (let key in outputjson.approximate_charges) {
            outputjson.approximate_charges[key] = parseFloat(outputjson.approximate_charges[key]).toFixed(2);
        }
        this.setState({
            conversions: outputjson
        }, () => {
            if (fromDate == "" && toDate == "") {
                this.getMessagingInsights();
                this.getMessageTemplateInsights();
                this.getNotificationsInsights();
                // this.getAllContactsInsights();
                this.getAllPositiveLeads();
            } else {
                loaderStateFalse();
            }
        })
    }
    // end for modified change dashboard pricing_analytics

    getMessagingInsights = () => {
        const { currentDate, startOfMonth, endOfMonth, upperBlockDataSet } = this.state;
        const { loaderStateTrue, loaderStateFalse } = this.props;
        // console.log("endOfMonth============", upperBlockDataSet.ph_no_block_value.replace(/\D/g, ''))
        loaderStateTrue();
        let filterData = { "metric_type": "analytics", "start": startOfMonth, "end": endOfMonth, "granularity": "DAY", "phone_numbers": [upperBlockDataSet.ph_no_block_value.replace(/\D/g, '')] };
        let data = {};
        data["filters"] = JSON.stringify(filterData)
        const promise = new Promise((resolve, reject) => {
            DashboardController.messagingInsightsDetails(data).then((response) => {
                const totalSentCount = response?.data?.analytics?.data_points?.reduce((total, dataPoint) => total + dataPoint.sent, 0);
                const totalDeliveredCount = response?.data?.analytics?.data_points?.reduce((total, dataPoint) => total + dataPoint.delivered, 0);
                this.setState({
                    messaging: {
                        "message_sent": totalSentCount,
                        "message_delivered": totalDeliveredCount
                    }
                })
                //loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                loaderStateFalse();
            })
        })
        return promise;
    }

    getMessageTemplateInsights = () => {
        const { loaderStateTrue, loaderStateFalse, userCredentials } = this.props;
        // console.log("endOfMonth============", upperBlockDataSet.ph_no_block_value.replace(/\D/g, ''))
        loaderStateTrue();
        // let filterData = { "org_id": userCredentials.user_details.org_id };
        /* let filterData = {};
        let data = {};
        filterData["org_id"] = userCredentials.user_details.org_id;
        filterData["offset"] = 0;
        filterData["limit"] = 5;
        data["filters"] = JSON.stringify(filterData) */
        const promise = new Promise((resolve, reject) => {
            DashboardController.messageTemplateInsightsDetailsRankWise().then((response) => {
                const sortedTemplates = response.data.sort((a, b) => b.id - a.id);
                const latestFiveTemplates = sortedTemplates.slice(0, 7);
                // console.log("latestTemplateIds============", latestFiveTemplates)
                this.setState({
                    messageTemplate: latestFiveTemplates
                })
                //loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                loaderStateFalse();
            })
        })
        return promise;
    }

    getNotificationsInsights = () => {
        const { loaderStateTrue, loaderStateFalse, userCredentials } = this.props;
        // console.log("endOfMonth============", upperBlockDataSet.ph_no_block_value.replace(/\D/g, ''))
        loaderStateTrue();
        // let filterData = { "org_id": userCredentials.user_details.org_id };
        let filterData = {};
        let data = {};
        filterData["org_id"] = userCredentials.user_details.org_id;
        filterData["offset"] = 0;
        filterData["limit"] = 5;
        data["filters"] = JSON.stringify(filterData)
        const promise = new Promise((resolve, reject) => {
            DashboardController.notificationsInsightsDetails(data).then((response) => {
                const sortedNotifications = response.data.sort((a, b) => b.id - a.id);
                const latestFiveNotifications = sortedNotifications.slice(0, 5);
                // console.log("latestFiveNotifications============", latestFiveNotifications)
                this.setState({
                    notificationsInsights: latestFiveNotifications
                })
                //loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                loaderStateFalse();
            })
        })
        return promise;
    }

    getAllContactsInsights = () => {
        const { loaderStateTrue, loaderStateFalse, userCredentials } = this.props;
        loaderStateTrue();
        let filterData = {};
        let data = {};
        filterData["offset"] = 0;
        filterData["limit"] = 5;
        data["filters"] = JSON.stringify(filterData)
        const promise = new Promise((resolve, reject) => {
            DashboardController.contactsInsightsDetails(data).then((response) => {
                // const sortedContacts = response.data.sort((a, b) => b.id - a.id);
                // const latestFiveContacts = sortedContacts.slice(0, 5);
                const latestFiveContacts = response.data.slice(0, 5);
                // console.log("latestFiveContacts============", latestFiveContacts)
                this.setState({
                    contactsInsights: latestFiveContacts
                })
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                loaderStateFalse();
            })
        })
        return promise;
    }

    getAllPositiveLeads = () => {
        const { loaderStateTrue, loaderStateFalse, userCredentials } = this.props;
        loaderStateTrue();
        let filterData = {};
        let data = {};
        filterData["org_id"] = userCredentials.user_details.org_id;
        filterData["status"] = 0;
        filterData["group_by"] = true;
        filterData["offset"] = 0;
        filterData["limit"] = 5;
        data["filters"] = JSON.stringify(filterData)
        const promise = new Promise((resolve, reject) => {
            DashboardController.contactsPositiveLeads(data).then((response) => {
                // const sortedContacts = response.data.sort((a, b) => b.id - a.id);
                // const latestFiveContacts = sortedContacts.slice(0, 5);
                // const latestFiveContacts = response.data.slice(0, 5);
                const latestFiveContacts = response.data
                    .sort((a, b) => moment(b.chat_date, "DD-MM-YYYY hh:mm:ss a") - moment(a.chat_date, "DD-MM-YYYY hh:mm:ss a"))
                    .slice(0, 5);
                // console.log("latestFiveContacts============", latestFiveContacts)
                this.setState({
                    contactsInsights: latestFiveContacts
                })
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                loaderStateFalse();
            })
        })
        return promise;
    }

    upperBlockUi = () => {
        const { upperBlockDataSet } = this.state;
        return (
            <div className="totalworkercontent contactDetailsBox">
                <ErrorBoundary title="GlobalHeaderFilter Error">
                    <GlobalHeaderFilter
                        headerFliterContent={
                            <div className='col-md-12' style={{ margin: "-9px 0px" }}>
                                <div className='row'>
                                    <div className='ph_no_block'>
                                        <p>Phone Number</p>
                                        <span>{upperBlockDataSet.ph_no_block_value}</span>
                                    </div>
                                    <hr className="horizontal_line" />
                                    <div className='display_name_block'>
                                        <p>Display Name</p>
                                        <span>{upperBlockDataSet.display_name_block_value}</span>
                                    </div>
                                    <hr className="horizontal_line" />
                                    <div className='message_limit_block'>
                                        <p>
                                            Message Limit
                                            <OverlayTrigger overlay={
                                                <Tooltip>No of conversation you can initiate for a single day</Tooltip>
                                            } placement='bottom'>
                                                <i className="fa fa-info-circle" aria-hidden="true" style={{ color: "gray" }}></i>
                                            </OverlayTrigger>
                                        </p>
                                        <span>{upperBlockDataSet.message_limit_block_value}</span>
                                    </div>
                                    <hr className="horizontal_line" />
                                    <div className='quality_rating_block'>
                                        <p>
                                            Quality Rating
                                            <OverlayTrigger overlay={
                                                <Tooltip>
                                                    Quality rating is based on how messages have been received by recipients over the past seven days and is weighted by recency. It is determined by a combination of quality signals from conversations between businesses and users. Examples include user feedback signals such as blocks, reports and the reasons that users provide when they block a business.
                                                </Tooltip>
                                            } placement='bottom'>
                                                <i className="fa fa-info-circle" aria-hidden="true" style={{ color: "gray" }}></i>
                                            </OverlayTrigger>
                                        </p>
                                        <span>
                                            {upperBlockDataSet.quality_rating_block_value}
                                        </span>
                                    </div>
                                    <hr className="horizontal_line" />
                                    <div className='ph_no_status_block'>
                                        <p>Phone Number Status</p>
                                        <span>{upperBlockDataSet.ph_no_status_block_value}</span>
                                    </div>
                                </div>
                            </div>
                        }
                    />
                </ErrorBoundary>
            </div>
        )
    }

    // for change dashboard
    handleSelectedDayRange = (e) => {
        this.setState({
            selectedDayRange: e
        }, () => {
            const formatDate = (date) => {
                if (!date || !date.year || !date.month || !date.day) return null;
                const month = String(date.month).padStart(2, '0');
                const day = String(date.day).padStart(2, '0');
                return `${date.year}-${month}-${day}`;
            };

            const fromDate = formatDate(e?.from);
            const toDate = formatDate(e?.to);

            if (fromDate && toDate) {
                // this.getConversionsInsights(fromDate, toDate);
                this.getPricingInsights(fromDate, toDate);
            }
        });
    };

    resetDatePicker = (selectedDay) => {
        // const fromDate = "";
        // const toDate = "";
        // this.getConversionsInsights(fromDate, toDate);
        const formatDate = (date) => {
            if (!date || !date.year || !date.month || !date.day) return null;
            const month = String(date.month).padStart(2, '0');
            const day = String(date.day).padStart(2, '0');
            return `${date.year}-${month}-${day}`;
        };

        const fromDate = formatDate(selectedDay?.from);
        const toDate = formatDate(selectedDay?.to);

        if (fromDate && toDate) {
            // this.getConversionsInsights(fromDate, toDate);
            this.getPricingInsights(fromDate, toDate);
        }
    }

    formatInputValue = () => {
        const { selectedDayRange } = this.state;
        if (!selectedDayRange.from || !selectedDayRange.to) return '';

        const fromDate = new Date(selectedDayRange.from.year, selectedDayRange.from.month - 1, selectedDayRange.from.day);
        const toDate = new Date(selectedDayRange.to.year, selectedDayRange.to.month - 1, selectedDayRange.to.day);

        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        const formattedFrom = fromDate.toLocaleDateString('en-US', options);
        const formattedTo = toDate.toLocaleDateString('en-US', options);

        const today = new Date();
        const isCurrentMonth =
            fromDate.getFullYear() === today.getFullYear() && fromDate.getMonth() === today.getMonth() &&
            toDate.getFullYear() === today.getFullYear() && toDate.getMonth() === today.getMonth();

        return isCurrentMonth ? `This month : ${formattedFrom} - ${formattedTo}` : `${formattedFrom} - ${formattedTo}`;
    }

    clearFromToDate = () => {
        this.setCurrentMonthRange(true);
        // this.resetDatePicker()
    }

    todayDate = () => ({
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate(),
    });
    // end for change dashboard

    conversionMessagingBlockUi = () => {
        const { conversions, messaging, currencyCode, selectedDayRange } = this.state;
        console.log("conversions========>", conversions);

        const conversionBlock = this.dashboardMenuLabledata().find(item => item.field_name == "conversion_block");
        const messageingBlock = this.dashboardMenuLabledata().find(item => item.field_name == "messageing_block");
        return (
            <div className='col-md-12'>
                <div className='row'>
                    {conversionBlock ? (
                        <div className="conversion_block commonSpace">
                            <ErrorBoundary title="GlobalHeaderFilter Error">
                                <GlobalHeaderFilter
                                    headerFliterContent={
                                        <div className='innerDiv'>
                                            <p>
                                                <img className='lable_text_icon' src={require('../../../Utility/Public/images/icon/conversation.png')} /> {conversionBlock.modified_field_caption}&nbsp;
                                                <OverlayTrigger overlay={
                                                    <Tooltip>Provide the cost and conversation information for this WABA</Tooltip>
                                                } placement='bottom'>
                                                    <i className="fa fa-info-circle" style={{ cursor: "pointer", color: "gray" }}></i>
                                                </OverlayTrigger>
                                                {/* // for change dashboard */}
                                                {/* <span>
                                                    <div className="callbackdatepikDashboard">
                                                        <DatePicker
                                                            value={selectedDayRange}
                                                            onChange={this.handleSelectedDayRange}
                                                            formatInputText={this.formatInputValue}
                                                            inputPlaceholder={`Select Date Range`}
                                                            inputClassName='padY border-left-0 shadow-none text-md'
                                                            calendarRangeBetweenClassName='bg-info text-white'
                                                            calendarRangeStartClassName='bg-info text-white'
                                                            calendarRangeEndClassName='bg-info text-white'
                                                            calendarPopperPosition="bottom"
                                                            maximumDate={this.todayDate()} // Disable future dates
                                                        />
                                                        {selectedDayRange.from != null && selectedDayRange.from != "" && selectedDayRange.to != null && selectedDayRange.to != "" ?
                                                            <button type='button' className='dateclearbutton dateclearbuttonhome' onClick={() => this.clearFromToDate()}>
                                                                <img src={require('../../../Utility/Public/images/dropcloseicon.png')} className="dateClearIcon" />
                                                            </button>
                                                            : null}
                                                    </div>
                                                </span> */}
                                                {/* // end for change dashboard */}
                                            </p>
                                            {/* // for change dashboard */}
                                            <div className='row conv_block'>
                                                {Object.entries(conversions).map(([key, value], index) => (
                                                    <div className="inner_conv_block" key={index}>
                                                        <div className='inner_conv_block_title'>
                                                            <span>
                                                                {key.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())}
                                                            </span>
                                                            <span>
                                                                {key === "approximate_charges" ? currencyCode : ""} {value.total}
                                                            </span>
                                                        </div>
                                                        <div className='inner_body'>
                                                            {Object.entries(value)
                                                                .filter(([subKey]) =>
                                                                    ["marketing", "utility", "service"].includes(subKey)
                                                                )
                                                                .map(([subKey, subValue]) => {
                                                                    const formattedKey =
                                                                        subKey === "free tier"
                                                                            ? subKey.replace(/\s/g, "_")
                                                                            : subKey || "default";

                                                                    return (
                                                                        <div
                                                                            className={`${formattedKey}_decoretion inner_conv_block_body`}
                                                                            key={subKey}
                                                                        >
                                                                            <span>
                                                                                {subKey
                                                                                    .replace(/_/g, " ")
                                                                                    .replace(/\b\w/g, char => char.toUpperCase())}
                                                                            </span>

                                                                            <span>
                                                                                {key === "approximate_charges"
                                                                                    ? currencyCode
                                                                                    : ""}
                                                                                {" "}
                                                                                {subValue}
                                                                            </span>
                                                                        </div>
                                                                    );
                                                                })}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            {/* // end for change dashboard */}
                                            {/* <table className='conversion_table'>
                                                <thead>
                                                    <tr>
                                                        <td>Conversations</td>
                                                        <td>Free</td>
                                                        <td>Paid</td>
                                                        <td>Total</td>
                                                        <td>Approx Cost</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{conversions.business_initiated.conversion_name}</td>
                                                        <td>{conversions.business_initiated.free}</td>
                                                        <td>{conversions.business_initiated.paid}</td>
                                                        <td>{conversions.business_initiated.total}</td>
                                                        <td>{currencyCode} {conversions.business_initiated.approx_cost}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{conversions.user_initiated.conversion_name}</td>
                                                        <td>{conversions.user_initiated.free}</td>
                                                        <td>{conversions.user_initiated.paid}</td>
                                                        <td>{conversions.user_initiated.total}</td>
                                                        <td>{currencyCode} {conversions.user_initiated.approx_cost}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{conversions.unknown.conversion_name}</td>
                                                        <td>{conversions.unknown.free}</td>
                                                        <td>{conversions.unknown.paid}</td>
                                                        <td>{conversions.unknown.total}</td>
                                                        <td>{currencyCode} {conversions.unknown.approx_cost}</td>
                                                    </tr>
                                                </tbody>
                                            </table> */}
                                        </div>
                                    }
                                />
                            </ErrorBoundary>
                        </div>
                    ) : <></>}
                    {messageingBlock ? (
                        <div className="messageing_block commonSpace">
                            <ErrorBoundary title="GlobalHeaderFilter Error">
                                <GlobalHeaderFilter
                                    headerFliterContent={
                                        <div className='innerDiv messagingInnerBox'>
                                            <p>
                                                <i className="fa fa-comment-o"></i> {messageingBlock.modified_field_caption}&nbsp;
                                                <OverlayTrigger overlay={
                                                    <Tooltip>Provides the number and type of messages sent and delivered by the phone numbers associated with this WABA</Tooltip>
                                                } placement='bottom'>
                                                    <i className="fa fa-info-circle" style={{ cursor: "pointer", color: "gray" }}></i>
                                                </OverlayTrigger>
                                            </p>
                                            <div className='body'>
                                                <span className='msg_sent_text'>Message sent</span>
                                                <span className='msg_sent_icon'>
                                                    <OverlayTrigger overlay={
                                                        <Tooltip>Message sent</Tooltip>
                                                    } placement='bottom'>
                                                        <i className="fa fa-info-circle message" aria-hidden="true" style={{ color: "gray" }}></i>
                                                    </OverlayTrigger>
                                                </span>
                                                <span className='msg_sent_value'>{messaging.message_sent}</span>
                                            </div>
                                            <div className='body'>
                                                <span className='msg_sent_text'>Message delivered</span>
                                                <span className='msg_sent_icon'>
                                                    <OverlayTrigger overlay={
                                                        <Tooltip>Message delivered</Tooltip>
                                                    } placement='bottom'>
                                                        <i className="fa fa-info-circle message" aria-hidden="true" style={{ color: "gray" }}></i>
                                                    </OverlayTrigger>
                                                </span>
                                                <span className='msg_sent_value'>{messaging.message_delivered}</span>
                                            </div>
                                        </div>
                                    }
                                />
                            </ErrorBoundary>
                        </div>
                    ) : <></>}
                </div>
            </div>
        )
    }

    pricingAnalyticsBlockUi = () => {
        const { pricingAnalyticsDataSet, selectedDayRange, messageTemplate } = this.state;
        const broadcastingTemplateBlock = this.dashboardMenuLabledata().find(item => item.field_name == "message_template_block");
        return (
            <div className='col-md-12'>
                <div className='row midSecpanel'>

                    {/* ========== Broadcasting Templates block ========== */}
                    {broadcastingTemplateBlock && ((this.state.fbMessageTemplatePermissionTab && (this.props.userCredentials?.user_details?.user_type == 'user' || this.props.userCredentials?.user_details?.user_type == 'staff')) || (this.props.userCredentials?.user_details?.user_type == 'admin')) ? (
                        <div className="message_template_block commonSpace">
                            <ErrorBoundary title="GlobalHeaderFilter Error">
                                <GlobalHeaderFilter
                                    headerFliterContent={
                                        <div className='innerDiv'>
                                            <p><img className='lable_text_icon' src={require('../../../Utility/Public/images/icon/broadcast.png')} /> {broadcastingTemplateBlock.modified_field_caption}</p>
                                            <table className='message_template_table'>
                                                <thead>
                                                    <tr>
                                                        <td>Name</td>
                                                        <td>Status</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        messageTemplate.map((item) => (
                                                            <tr key={item.id}>
                                                                <td>
                                                                    {item?.template_display_name.length > 22 ?
                                                                        <OverlayTrigger overlay={<Tooltip>{item?.template_display_name}</Tooltip>}>
                                                                            <span>{item?.template_display_name.length > 22 && (item?.template_display_name).substring(0, 22) + "..."}</span>
                                                                        </OverlayTrigger>
                                                                        : item?.template_display_name
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {item.template_status == "PENDING" ?
                                                                        <Badge variant='warning'>{item.template_status}</Badge> : item.template_status == "REJECTED" ? <Badge variant='danger'>{item.template_status}</Badge> : <Badge variant='success'>{item.template_status}</Badge>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                            <span className='more_details_sec' onClick={this.redirectToBroadcastingTemplateTab}>More...</span>
                                        </div>
                                    }
                                />
                            </ErrorBoundary>
                        </div>
                    ) : <></>}
                    {/* ========== Broadcasting Templates block end========== */}

                    <div className="pricing_template_block commonSpace">
                        <ErrorBoundary title="GlobalHeaderFilter Error">
                            <GlobalHeaderFilter
                                headerFliterContent={
                                    <div className='innerDiv'>
                                        <span>
                                            <div className="callbackdatepikDashboard">
                                                <DatePicker
                                                    value={selectedDayRange}
                                                    onChange={this.handleSelectedDayRange}
                                                    formatInputText={this.formatInputValue}
                                                    inputPlaceholder={`Select Date Range`}
                                                    inputClassName='padY border-left-0 shadow-none text-md'
                                                    calendarRangeBetweenClassName='bg-info text-white'
                                                    calendarRangeStartClassName='bg-info text-white'
                                                    calendarRangeEndClassName='bg-info text-white'
                                                    calendarPopperPosition="bottom"
                                                    maximumDate={this.todayDate()} // Disable future dates
                                                />
                                                {selectedDayRange.from != null && selectedDayRange.from != "" && selectedDayRange.to != null && selectedDayRange.to != "" ?
                                                    <button type='button' className='dateclearbutton dateclearbuttonhome' onClick={() => this.clearFromToDate()}>
                                                        <img src={require('../../../Utility/Public/images/dropcloseicon.png')} className="dateClearIcon" />
                                                    </button>
                                                    : null}
                                            </div>
                                        </span>
                                        {pricingAnalyticsDataSet && Object.keys(pricingAnalyticsDataSet).length > 0 && Object.keys(pricingAnalyticsDataSet.datasets).length > 0 ?
                                            <PricingAnalyticsChart
                                                datasets={pricingAnalyticsDataSet?.datasets}
                                                labels={pricingAnalyticsDataSet?.labels}
                                            />
                                            :
                                            <div className='no_data_available_sec'>No Data Available</div>
                                        }
                                    </div>
                                }
                            />
                        </ErrorBoundary>
                    </div>
                </div>
            </div>
        )
    }

    messagetemplateNotificationBlockUi = () => {
        const { messageTemplate, notificationsInsights, contactsInsights } = this.state;
        const broadcastingTemplateBlock = this.dashboardMenuLabledata().find(item => item.field_name == "message_template_block");
        const campaignBlock = this.dashboardMenuLabledata().find(item => item.field_name == "notification_block");
        const contactBlock = this.dashboardMenuLabledata().find(item => item.field_name == "contacts_block");
        // console.log("notificationsInsights============", notificationsInsights);

        return (
            <div className='col-md-12'>
                <div className='row'>
                    {/* ========== Campaign Broadcasting block ========== */}
                    {campaignBlock && ((this.state.campaignBroadcastingPermissionTab && (this.props.userCredentials?.user_details?.user_type == 'user' || this.props.userCredentials?.user_details?.user_type == 'staff')) || (this.props.userCredentials?.user_details?.user_type == 'admin')) ? (
                        <div className="notification_block commonSpace">
                            <ErrorBoundary title="GlobalHeaderFilter Error">
                                <GlobalHeaderFilter
                                    headerFliterContent={
                                        <div className='innerDiv'>
                                            <p><img className='lable_text_icon' src={require('../../../Utility/Public/images/icon/campaign.png')} /> {campaignBlock.modified_field_caption}</p>

                                            <CampaignChart />

                                            <span className='more_details_sec' onClick={this.redirectToCampaignBroadcastingTab}>More...</span>

                                            {/* <table className='notification_table'>
                                                <thead>
                                                    <tr>
                                                        <td>Name</td>
                                                        <td>Status</td>
                                                        <td>Stats</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        notificationsInsights.map((item) => (
                                                            <tr key={item.id}>
                                                                <td>{item.campaign_name}</td>
                                                                <td>
                                                                    {item.hasOwnProperty('send_at') && item.send_at == null ? <Badge variant='warning'>PENDING</Badge> : <Badge variant='success'>COMPLETED</Badge>}
                                                                </td>
                                                                <td>
                                                                    <OverlayTrigger overlay={
                                                                        <Tooltip>Sent</Tooltip>
                                                                    } placement='bottom'>
                                                                        <span className='send_status'>{item.send_status_count} </span>
                                                                    </OverlayTrigger>
                                                                    |
                                                                    <OverlayTrigger overlay={
                                                                        <Tooltip>Delivered</Tooltip>
                                                                    } placement='bottom'>
                                                                        <span className='delivered_status'> {item.delivered_status_count} </span>
                                                                    </OverlayTrigger>
                                                                    |
                                                                    <OverlayTrigger overlay={
                                                                        <Tooltip>Read</Tooltip>
                                                                    } placement='bottom'>
                                                                        <span className='read_status'> {item.read_status_count} </span>
                                                                    </OverlayTrigger>
                                                                    |
                                                                    <OverlayTrigger overlay={
                                                                        <Tooltip>Failed</Tooltip>
                                                                    } placement='bottom'>
                                                                        <span className='failed_status'> {item.failed_status_count}</span>
                                                                    </OverlayTrigger>

                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table> */}
                                            {/* <span className='more_details_sec' onClick={this.redirectToCampaignBroadcastingTab}>More...</span> */}
                                        </div>
                                    }
                                />
                            </ErrorBoundary>
                        </div>
                    ) : <></>}
                    {/* ========= Campaign Broadcasting block end========== */}
                    {/* ========= positive leads block end========== */}
                    {contactBlock && ((this.state.contactPermissionTab && (this.props.userCredentials?.user_details?.user_type == 'user' || this.props.userCredentials?.user_details?.user_type == 'staff')) || (this.props.userCredentials?.user_details?.user_type == 'admin')) ? (
                        <TaskCalendar
                            tasks={this.state.taskData && this.state.taskData.length > 0 ? this.state.taskData : []}
                            refreshTaskData={this.getTaskData}
                        />

                    ) : <></>}
                    {/* ========= positive leads block end========== */}

                </div>
            </div>
        )
    }

    openWhatsappChatFn = (data) => {
        console.log('data====>', data)
        this.setState({
            globalChatPhoneNumber: data?.CustomerDetails?.phone_number,
            globalChatName: data?.CustomerDetails?.name,
            lastChatInitiatedAt: data?.CustomerDetails?.last_chat_initiated_at,
            groupMessage: false,
            groupMessageData: {}
        }, () => {
            this.setState({
                globalChatModalFlag: true,
            })
        })
    }

    redirectToBroadcastingTemplateTab = () => {
        this.props.history.push(`/${localStorage.getItem('i18nextLng')}/template`);
        localStorage.setItem("selectedTabName", 'fbMessageTemplate')
    }

    redirectToCampaignBroadcastingTab = () => {
        this.props.history.push(`/${localStorage.getItem('i18nextLng')}/chat`);
        localStorage.setItem("selectedTabName", 'CampaignBroadcasting')
    }

    redirectToContactTab = () => {
        this.props.history.push(`/${localStorage.getItem('i18nextLng')}/contact_management`);
        localStorage.setItem("selectedTabName", 'contactGroup')
    }

    redirectToNotificationTab = () => {
        this.props.history.push(`/${localStorage.getItem('i18nextLng')}/chat`);
        localStorage.setItem("selectedTabName", 'notificationChatTab')
    }

    contactQuicklinkBlockUi = () => {
        const { contactsInsights } = this.state;
        const contactBlock = this.dashboardMenuLabledata().find(item => item.field_name == "contacts_block");
        const quickLinkBlock = this.dashboardMenuLabledata().find(item => item.field_name == "quick_links_block");
        return (
            <div className='col-md-12'>
                <div className='row'>
                    {/* {contactBlock && ((this.state.contactPermissionTab && (this.props.userCredentials?.user_details?.user_type == 'user' || this.props.userCredentials?.user_details?.user_type == 'staff')) || (this.props.userCredentials?.user_details?.user_type == 'admin')) ? (
                        <div className="contacts_block commonSpace">
                            <ErrorBoundary title="GlobalHeaderFilter Error">
                                <GlobalHeaderFilter
                                    headerFliterContent={
                                        <div className='innerDiv'>
                                            <p><i className="fa fa-address-book"></i> {contactBlock.modified_field_caption}</p>
                                            <table className='contact_table'>
                                                <thead>
                                                    <tr>
                                                        <td>Name</td>
                                                        <td>Last Conversation</td>
                                                        <td>Number</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        contactsInsights.map((item) => (
                                                            <tr key={item.id}>
                                                                <td>{item.profile_name || ""}</td>
                                                                <td>{item.chat_date || ""}</td>
                                                                <td>{Utility.formatPhoneNumber(`+${item.phone_number}`)}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                            <span className='more_details_sec' onClick={this.redirectToNotificationTab}>More...</span>
                                        </div>
                                    }
                                />
                            </ErrorBoundary>
                        </div>
                    ) : <></>} */}
                    {quickLinkBlock ? (
                        < div className="quick_links_block commonSpace">
                            <ErrorBoundary title="GlobalHeaderFilter Error">
                                <GlobalHeaderFilter
                                    headerFliterContent={
                                        <div className='innerDiv'>
                                            <div className='quick_links'>
                                                <p><i className="fa fa-link"></i> {quickLinkBlock.modified_field_caption}</p>
                                            </div>
                                            <div className='quick_links_body_sec'>
                                                <div className='links'>
                                                    <a href='https://waliner.io/when-your-whatsapp-business-account-may-blocked/' target='_blank'>Blocked WhatsApp Business account?
                                                        <i className="fa fa-external-link"></i>
                                                    </a>
                                                </div>
                                                <div className='links'>
                                                    <a href='https://waliner.io/whatsapp-business-green-tick/' target='_blank'>How to request the green tick verification on WhatsApp?
                                                        <i className="fa fa-external-link"></i>
                                                    </a>
                                                </div>
                                                <div className='links'>
                                                    <a href='https://waliner.io/whatsapp-template-creation-rule/' target='_blank'>Whatsapp template creation rule
                                                        <i className="fa fa-external-link"></i>
                                                    </a>
                                                </div>
                                                <div className='links'>
                                                    <a href='https://waliner.io/send-bulk-message/' target='_blank'>How to send bulk message or scheduled bulk message
                                                        <i className="fa fa-external-link"></i>
                                                    </a>
                                                </div>
                                                <div className='links'>
                                                    <a href='https://waliner.io/external-message-sending/' target='_blank'>Integrate seamless API for effortless whatsApp message send
                                                        <i className="fa fa-external-link"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                />
                            </ErrorBoundary>
                        </div>
                    ) : <></>}
                </div>
            </div >
        )
    }

    globalChatModalClose = () => {
        this.setState({
            globalChatModalFlag: false,
            globalChatPhoneNumber: "",
            globalChatName: "",
            lastChatInitiatedAt: "",
            groupMessage: false,
            groupMessageData: {},
            zoominzoomoutflag: ""
        })
    }


    zoominFunction = () => {
        //console.log("-----zoom in ------------")
        let zoominzoomoutflag = "zoominzoomoutclass"
        this.setState({
            zoominzoomoutflag: zoominzoomoutflag
        })
    }
    zoomoutFunction = () => {
        //console.log("-----zoom out ------------")
        let zoominzoomoutflag = ""
        this.setState({
            zoominzoomoutflag: zoominzoomoutflag
        })
    }

    // calendar view task
    // taskBlockUi = () => {
    //     return <div>
    //         <TaskCalendar tasks={[]} />
    //     </div>
    // }
    // end

    render() {
        let roleName = this.props.userCredentials.hasOwnProperty('user_details') && this.props.userCredentials.user_details && this.props.userCredentials.user_details.hasOwnProperty('user_type') && this.props.userCredentials.user_details.user_type
        return (
            <div className="gridcontainer dashboardContainer" style={{ marginBottom: "2%" }}>
                <>
                    {this.upperBlockUi()}
                    {this.messagetemplateNotificationBlockUi()}
                    {this.pricingAnalyticsBlockUi()}
                    {this.conversionMessagingBlockUi()}
                    {/* {this.taskBlockUi()} */}
                    {this.contactQuicklinkBlockUi()}
                </>
                {/* global message modal */}
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={this.state.globalChatModalFlag}
                        onHide={this.globalChatModalClose}
                        className={` ${this.state.zoominzoomoutflag + ' ' + "modalcustomize mondimension modalWithGrid chatModal chatHistoryModalDialog chatHistoryModalCommon"}`}
                        footer={true}
                        closeButton={true}
                        saveShow={false}
                        zoominButton={this.state.zoominzoomoutflag != "" ? false : true}
                        zoomoutButton={this.state.zoominzoomoutflag != "" ? true : false}
                        zoomin={this.zoominFunction}
                        zoomout={this.zoomoutFunction}
                        liveChat={false}
                        body={<>
                            <ChatHistoryModal gridPhoneNumber={this.state.globalChatPhoneNumber} globalChatName={this.state.globalChatName} lastChatInitiatedAt={this.state.lastChatInitiatedAt} permissionRulesGridMode={this.state.permissionRulesGridMode?.length > 0 && this.state.permissionRulesGridMode} groupMessage={this.state.groupMessage} groupMessageData={this.state.groupMessageData} />
                        </>}
                        cancelShow={false}
                    />
                </ErrorBoundary>
            </div >
        );
    }
}


const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        roleWisePermission: globalState.mainReducerData.roleWisePermission,
        version: globalState.LoginReducer.version,
        localTimeZoneName: globalState.mainReducerData.localTimeZone,
        tabGridLabel: globalState.LoginReducer.tabGridLabel, // for control pannel added
    };
}

export default withRouter(connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setToken, setUserCredentials, logOutApp })
    (withTranslation()(Dashboard)));